import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";

function Jobdetails() {
  const apiUrl = API_URL;
  const [items, setItems] = useState("");
  const [industries, setIndustries] = useState([]);
  const [values, setValues] = useState("");
  const viewId = useParams();
  const jobId = viewId.jobid;

  useEffect(() => {
    const getComments = async () => {
      try {
        const postData = {
          jobid: jobId,
        };
        const res = await fetch(`${apiUrl}/admin/viewjobdetails`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(postData),
        });
        const data = await res.json();
        if (data.status !== 200) {
          throw new Error("Data not found");
        }
        setItems(data.data);
        setIndustries(data.data.jobIndustry);
        setValues(data.value);
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  console.log(industries);
  return (
    <div className="width90">
      <h2 className="pageTitle">View Job Details</h2>
      <div className="commonCntr">
        <form className="form-horizontal" action="">
          <div className="form-group">
            <label className="control-label col-sm-2 label">Job Title:</label>
            <div className="col-sm-10 mt-1">
              <span>{items.title}</span>
            </div>
            <div className="form-group mt-4">
                <label className="control-label col-sm-5 label">Status</label>
                <div className="col-sm-10 mt-1">
                <span>{items.status}</span>
            </div>
          </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Creator Name:
            </label>
            <div className="col-sm-10 mt-1">
              <span>{items.creatorname}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Creator Email:
            </label>
            <div className="col-sm-10 mt-1">
              <span>{items.creatoremail}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Job Description:
            </label>
            <div className="col-sm-10 mt-1">
              <span>{items.description}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Address:</label>
            <div className="col-sm-10 mt-1">
              <span>{items.address}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-7 label">
              Number Of positions:
            </label>
            <div className="col-sm-10 mt-1">
              <span>{items.no_position}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Specialism</label>
            <div className="col-sm-10 mt-1">
              <span>{items.specialism}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Date</label>
              <span>{items.date}</span>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Marked Completed by Creator</label>
              <span>{items.is_completed ===true ? "Yes": "No"}</span>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Marked Complete by Provider</label>
              <span>{items.is_completed_by_provider ===true ? "Yes": "No"}</span>
          </div>
          
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Time</label>
              <span>{items.time}</span>
          </div>

          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Industries</label>
            {items.industry_list ? (
              items.industry_list.map((e) => {
                return (
                  <span>{e.industry_name}, </span>
                );
              })
            ) : (
              <></>
            )}
          </div>

          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Skills</label>
            {items.category_list ? (
              items.category_list.map((e) => {
                return (
                  <span className="control-label col-sm-5">
                      {e.category_name}
                  </span>
                );
              })
            ) : (
              <></>
            )}
          </div>
          
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Sub Skills</label>
            {items.subcategory_list ? (
              items.subcategory_list.map((e) => {
                return (
                  <span className="control-label col-sm-5">
                    {e.subcategory_name}
                  </span>
                );
              })
            ) : (
              <></>
            )}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Providers Applied</label>
            <div className="col-sm-10 mt-1">
              {items.providers_applied
                ? items.providers_applied.map((e) => {
                    return (
                        <span>{e.name} - {e.email} - {e.status}</span>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Requested Providers</label>
            <div className="col-sm-10 mt-1">
              {items.requested_user_id
                ? items.requested_user_id.map((e) => {
                    return (
                        <span>{e.name} - {e.email} - {e.status}</span>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Rejected Providers</label>
            <div className="col-sm-10 mt-1">
              {items.rejected_user_id
                ? items.rejected_user_id.map((e) => {
                    return (
                      <>
                        <span>{e.name} - {e.email} - {e.status}</span>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Selected Providers</label>
            <div className="col-sm-10 mt-1">
              {items.selected_user_id
                ? items.selected_user_id.map((e) => {
                    return (
                      <>
                        <span>{e.name} - {e.email} - {e.status}</span>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Creators Feedback</label>
            <div className="col-sm-10 mt-1">
              {items.feedback_creator
                ? items.feedback_creator.map((e) => {
                    return (
                      <>
                        <span>{e.name} - {e.email} -  {e.feedback}</span>
                        <br/>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Provider Feedback</label>
            <div className="col-sm-10 mt-1">
              {items.feedback_provider
                ? items.feedback_provider.map((e) => {
                    return (
                      <>
                        <span>{e.name} - {e.email} -  {e.feedback}</span>
                        <br/>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-10 label">Job Images uploaded by users</label>
            <div className="col-sm-4  mt-1">
            {items.jobImage ? (
              items.jobImage.map((e) => { 
                return <img
                src={e}
                class="img-fluid small-image"
                alt="No Document uploaded yet"
              />
                })) : <></>
              }
            </div>
          </div>
          {/* <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">Job Image</label>
            {items.jobImage ? (
              items.jobImage.map((e) => {
                // eslint-disable-next-line jsx-a11y/alt-text
                return <img src={e} class="img-fluid small-image" alt="No Document uploaded yet"></img>
                  // <span className="control-label col-sm-5">
                  //   {e.subcategory_name}
                  // </span>
                // );
              })
            ) : (
              <></>
            )}
          </div> */}
        </form>
      </div>
    </div>
  );
}

export default Jobdetails;
